import { BaseError } from './BaseError';

/**
 * Erreur spécifique pour les problèmes liés à l'authentification (ex: échec de connexion, session expirée).
 */
export class AuthenticationError extends BaseError {
  /**
   * Type d'échec d'authentification (ex: 'INVALID_CREDENTIALS', 'SESSION_EXPIRED').
   */
  public readonly failureType?: string;

  /**
   * Crée une instance d'AuthenticationError.
   * @param message Le message d'erreur.
   * @param failureType Le type d'échec d'authentification (facultatif).
   * @param cause La cause originale de l'erreur (facultatif).
   */
  constructor(message: string, failureType?: string, cause?: unknown) {
    super(message, cause);
    Object.setPrototypeOf(this, AuthenticationError.prototype);
    this.name = 'AuthenticationError';
    this.failureType = failureType;
  }
}

